import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';

export function useDisplaySettings() {
  const { data } = useQuery({
    queryKey: ['settings-display'],
    queryFn: async () => {
      const res = await api.get('/api/settings');
      return {
        timezone: res.data?.data?.timezone || 'UTC',
        timeFormat: res.data?.data?.timeFormat || '12h',
      };
    },
    staleTime: 5 * 60 * 1000,
  });
  return data || { timezone: 'UTC', timeFormat: '12h' };
}
